export default {
  heading: {
    widgetName: "category",
    widgetID: "107",
    cardCount: "5",
    layoutName: "lob_widget",
    headline: "SHOP DUTY FREE NOW",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `certifiedsuper | Discover Certified Super Food outlets`,
      eventLabelCardClick: `certifiedsuper | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `certifiedsuper | headline | {{headline}}`,
      eventLabelView: `certifiedsuper | Discover Certified Super Food outlets`,
    },
  },

  data: [
      {
        image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_skincare.png",
        title: "Skincare",
        url: "https://www.airasia.com/shop/th/en/category/skincare",
        newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_fashion.png",
         title: "Fashion",
         url: "https://www.airasia.com/shop/th/en/category/fashion",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_makeup.png",
         title: "Makeup",
         url: "https://www.airasia.com/shop/th/en/category/make-up",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_hair.png",
         title: "Hair & Body",
         url: "https://www.airasia.com/shop/th/en/category/hair-and-body",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_electronic.png",
         title: "Electronics",
         url: "https://www.airasia.com/shop/th/en/category/electronics",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_food.png",
         title: "Food",
         url: "https://www.airasia.com/shop/th/en/category/food",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_health.png",
         title: "Health & Wellness",
         url: "https://www.airasia.com/shop/th/en/category/health-and-wellness",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_airasiaexclusive.png",
         title: "AirAsia Exclusive",
         url: "https://www.airasia.com/shop/th/en/category/airasia-exclusives",
          newTab: "TRUE"
      }
    ]
  }
